import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-legal-advice',
    templateUrl: './legal-advice.component.html',
    styleUrls: ['./legal-advice.component.css'],
    standalone: false
})
export class LegalAdviceComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Aviso Legal');
  }

}
